import { call, put, takeLatest } from 'redux-saga/effects';
import api from '../../../api-new/http';
import { appUrls } from '../../../api-new/urls';
import {
    fetchListPriceBoardFailure,
    FetchListPriceBoardRequestAction,
    fetchListPriceBoardSuccess,
} from './actions';
import { FETCH_LIST_PRICE_BOARD_REQUEST } from './constants';
import { ApiListPriceData, ListPriceBoardData } from './types';
import { SagaIterator } from 'redux-saga';


export const mapApiDataToPriceBoard = (data: ApiListPriceData): ListPriceBoardData => {
    return {
        ceiling: data["('listing', 'ceiling')"],
        floor: data["('listing', 'floor')"],
        ref_price: data["('listing', 'ref_price')"]
    };
};


function* fetchListPriceBoardSaga(action: FetchListPriceBoardRequestAction):SagaIterator {
    try {
        const response = yield call(() => api.get(`${appUrls.stockURL}/ticker/price-board/${action.payload}`));
        if (response) {
            // Map dữ liệu từ API sang cấu trúc `PriceBoardData`
            const mappedData = response.data.map((item: ApiListPriceData) => mapApiDataToPriceBoard(item));
            yield put(fetchListPriceBoardSuccess(mappedData));
        }

    } catch (error) {
        yield put(fetchListPriceBoardFailure(error as any));
    }
}

export function* rootListPriceBoardSaga(): Generator {
    yield takeLatest(FETCH_LIST_PRICE_BOARD_REQUEST, fetchListPriceBoardSaga);
}
